import { render, staticRenderFns } from "./adjustTab.vue?vue&type=template&id=29653c6b&scoped=true&"
import script from "./adjustTab.vue?vue&type=script&lang=js&"
export * from "./adjustTab.vue?vue&type=script&lang=js&"
import style0 from "./adjustTab.vue?vue&type=style&index=0&id=29653c6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29653c6b",
  null
  
)

export default component.exports